export default __webpack_public_path__ + "static/media/bedtime.39d89bc6.svg";